import React from "react";

const BASE_WIDTH = 14;
const BASE_HEIGHT = 14;

interface OwnProps {
  width?: number;
  height?: number;
  rotation?: string | number;
  color?: string;
}

export default function InfoIcon(props: OwnProps) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${BASE_WIDTH} ${BASE_HEIGHT}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6187_12389)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7 1.8125C5.49158 1.8125 4.04494 2.41172 2.97833 3.47833C1.91172 4.54494 1.3125 5.99158 1.3125 7.5C1.3125 9.00842 1.91172 10.4551 2.97833 11.5217C4.04494 12.5883 5.49158 13.1875 7 13.1875C8.50842 13.1875 9.95506 12.5883 11.0217 11.5217C12.0883 10.4551 12.6875 9.00842 12.6875 7.5C12.6875 5.99158 12.0883 4.54494 11.0217 3.47833C9.95506 2.41172 8.50842 1.8125 7 1.8125ZM0 7.5C0 5.64348 0.737498 3.86301 2.05025 2.55025C3.36301 1.2375 5.14348 0.5 7 0.5C8.85652 0.5 10.637 1.2375 11.9497 2.55025C13.2625 3.86301 14 5.64348 14 7.5C14 9.35652 13.2625 11.137 11.9497 12.4497C10.637 13.7625 8.85652 14.5 7 14.5C5.14348 14.5 3.36301 13.7625 2.05025 12.4497C0.737498 11.137 0 9.35652 0 7.5ZM5.6875 7.28125C5.6875 7.1072 5.75664 6.94028 5.87971 6.81721C6.00278 6.69414 6.1697 6.625 6.34375 6.625H7.21875C7.3928 6.625 7.55972 6.69414 7.68279 6.81721C7.80586 6.94028 7.875 7.1072 7.875 7.28125V9.6875H8.09375C8.2678 9.6875 8.43472 9.75664 8.55779 9.87971C8.68086 10.0028 8.75 10.1697 8.75 10.3438C8.75 10.5178 8.68086 10.6847 8.55779 10.8078C8.43472 10.9309 8.2678 11 8.09375 11H6.34375C6.1697 11 6.00278 10.9309 5.87971 10.8078C5.75664 10.6847 5.6875 10.5178 5.6875 10.3438C5.6875 10.1697 5.75664 10.0028 5.87971 9.87971C6.00278 9.75664 6.1697 9.6875 6.34375 9.6875H6.5625V7.9375H6.34375C6.1697 7.9375 6.00278 7.86836 5.87971 7.74529C5.75664 7.62222 5.6875 7.4553 5.6875 7.28125ZM7 5.75C7.23206 5.75 7.45462 5.65781 7.61872 5.49372C7.78281 5.32962 7.875 5.10706 7.875 4.875C7.875 4.64294 7.78281 4.42038 7.61872 4.25628C7.45462 4.09219 7.23206 4 7 4C6.76794 4 6.54538 4.09219 6.38128 4.25628C6.21719 4.42038 6.125 4.64294 6.125 4.875C6.125 5.10706 6.21719 5.32962 6.38128 5.49372C6.54538 5.65781 6.76794 5.75 7 5.75Z'
          fill={props.color ?? "#2F2F2F"}
        />
      </g>
      <defs>
        <clipPath id='clip0_6187_12389'>
          <rect
            width='14'
            height='14'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
